export default "__VITE_ASSET__BxKfjTI8__"